exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".thumbnail .caption{\n    position: absolute;\n    bottom: 30px;\n    color: white;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/recommend.css
// module id = 1131
// module chunks = 0